{
  "certificates": {
    "modal": {
      "labels": {
        "productionSite": "Site de production"
      }
    }
  },
  "columns": {
    "createdAt": "Création",
    "lang": "Langue",
    "question": "Question",
    "updatedAt": "Mise à jour"
  },
  "customFields": {
    "add_enum_value": "Ajouter",
    "constraints": {
      "enum": "Liste (choix simple)",
      "multi_enum": "Liste (choix multiples)",
      "number": "Nombre",
      "string": "Texte libre"
    },
    "create": "Donnée complémentaire",
    "enum_values": "Options",
    "labels": {
      "constraint": "Type de valeur",
      "csvColumnName": "Nom de la colonne dans le csv",
      "documentRequirement": "Requis pour la validation du document",
      "ecobalyseField": "Référence Ecobalyse",
      "ecobalyseFieldValue": "Champ ecobalyse correspondant",
      "fieldRequirement": "Requis pour la validation du champ",
      "forActivity": "forActivity",
      "max": "Maximum",
      "message": "message",
      "min": "Minimum",
      "onActivity": "onActivity",
      "organization": "organization",
      "orginalText": "Label"
    },
    "placeholders": {
      "constraint": "Type de donnée",
      "csvColumnName": "Nom de la colonne dans le csv",
      "documentRequirement": "Requis pour la validation du document",
      "ecobalyseField": "Sélectionner",
      "ecobalyseFieldValue": "Sélectionner",
      "fieldRequirement": "Requis pour la validation du champ",
      "forActivity": "forActivity",
      "max": "999.9",
      "message": "message",
      "min": "0.0",
      "onActivity": "onActivity",
      "organization": "organization",
      "orginalText": "Label"
    },
    "submit": "Valider",
    "syncToProducts": {
      "cancel": "Annuler",
      "confirm": "Confirmer",
      "confirmation": "Cette action synchronisera tous les champs personnalisés pour les produits de l'organisation sélectionnée. Êtes-vous sûr de vouloir continuer ?",
      "warning": "Attention"
    },
    "tooltips": {
      "constraint": "Type de valeur",
      "csvColumnName": "Nom de la colonne dans le csv",
      "documentRequirement": "Requis pour la validation du document",
      "ecobalyseField": "Référence Ecobalyse",
      "ecobalyseFieldValue": "Champ ecobalyse correspondant",
      "fieldRequirement": "Requis pour la validation du champ",
      "forActivity": "for Activity",
      "max": "Maximum",
      "message": "message",
      "min": "Minimum",
      "onActivity": "on Activity",
      "organization": "organization",
      "orginalText": "Label"
    },
    "update": "Modifier"
  },
  "faq": {
    "modal": {
      "create": {
        "success": "Question créée avec succès !",
        "title": "Ajouter"
      },
      "edit": {
        "success": "Question mise à jour avec succès !",
        "title": "Modifier"
      },
      "labels": {
        "answer": "Réponse",
        "category": "Section",
        "lang": "Langue",
        "question": "Question"
      },
      "placeholders": {
        "answer": "Votre réponse",
        "category": "Sélectionner",
        "lang": "Sélectionner",
        "question": "Votre question"
      },
      "submit": "Valider"
    }
  },
  "ingestion": {
    "retry": {
      "blank": "Relancer l'ingestion en blanc",
      "products": "Relancer l'ingestion de produits"
    }
  },
  "invoices": {
    "createButton": "Ajouter",
    "modal": {
      "labels": {
        "amount": "Montant",
        "issueDate": "Date d'émission",
        "reference": "Référence"
      },
      "placeholders": {
        "amount": "Saisissez le montant de la facture",
        "issueDate": "Choisissez une date d'émission",
        "reference": "Saisissez la référence de la facture"
      },
      "submit": "Valider",
      "success": "Facture envoyée !",
      "title": "Nouvelle Facture"
    }
  },
  "mapping": {
    "modal": {
      "delete": {
        "areYouSureText": "Voulez-vous vraiment supprimer le mapping pour \"{{alias}}\" ({{label}}) ?",
        "cancelText": "Annuler",
        "confirmText": "Supprimer",
        "title": "Confirmation de suppression"
      },
      "update": {
        "areYouSureText": "Voulez-vous vraiment changer \"{{alias}}\" de \"{{label}}\" à \"{{newLabel}}\" ?",
        "cancelText": "Annuler",
        "confirmText": "Mettre à jour",
        "title": "Confirmation de mise à jour"
      }
    },
    "none": "Aucun"
  },
  "materialTypes": {
    "sort": {
      "operationChainName": "Chaîne de traçabilité",
      "originalText": "Texte original"
    }
  },
  "plan": {
    "agecProductPagePlan": {
      "advanced": "Moteur de recherche fiches produit + lien / QR code unique par référence produit",
      "essential": "Moteur de recherche fiches produit",
      "label": "Accès aux fiches produit",
      "starter": "Pas de fiches produits"
    },
    "certificatesPlan": {
      "advanced": "Désactivé",
      "expert": "Activé",
      "label": "Plan certificats"
    },
    "customFieldsPlan": {
      "advanced": "Désactivé",
      "expert": "Activé",
      "label": "Données complémentaires"
    },
    "lcaCustomizationPlan": {
      "advanced": "Aucune analyse du cycle de vie",
      "expert": "Calcul et affichage des analyses du cycle de vie",
      "label": "Analyse du cycle de vie"
    },
    "outputCustomizationPlan": {
      "advanced": "Design personnalisé (logo + couleur de la marque)",
      "essential": "Format Trace For Good",
      "expert": "Format et contenu personnalisé",
      "label": "Personnalisation des fiches produit"
    },
    "rduePlan": {
      "label": "Plan RDUE",
      "no": "non",
      "yes": "oui"
    },
    "zalandoPlan": {
      "label": "Plan Zalando",
      "no": "non",
      "yes": "oui"
    }
  },
  "prodSiteFieldDefs": {
    "columns": {
      "activitiesValue": "{{length}} activités",
      "enumValues": "{{length}} valeurs"
    },
    "create": "Nouveau champ de site de production",
    "labels": {
      "activities": "Activités",
      "allActivities": "Toutes les activités",
      "orginalText": "Label",
      "type": "Type"
    },
    "placeholders": {
      "activities": "Sélectionnez",
      "orginalText": "Saisissez une clé de traduction",
      "type": "Type"
    }
  },
  "productTypes": {
    "sort": {
      "operationChainName": "operationChainName",
      "originalText": "originalText"
    }
  },
  "standards": {
    "search": {
      "label": "label"
    },
    "sort": {
      "certificateTypeCount": "Nombre de certificats",
      "id": "ID",
      "name": "Nom"
    }
  },
  "tabs": {
    "certificatesTypes": "Standards & Certificats",
    "customFields": "Données complémentaires",
    "exports": "Exports",
    "faq": "FAQ",
    "general": "Général",
    "ingestion": "Ingestion",
    "ingestionSettings": "Paramètres d'ingestion",
    "invoices": "Factures",
    "mapping": "Référentiels",
    "masterLists": "Master Lists",
    "materialTypes": "Types de matériaux",
    "organizations": "Entreprises",
    "prodSiteFields": "Site de production",
    "productTypes": "Catégories de produits",
    "security": "Sécurité",
    "translations": "Traductions"
  },
  "title": "Administration",
  "translations": {
    "search": {
      "label": "Recherche"
    }
  }
}
